import "./App.css";
import { Route, Routes } from "react-router-dom";
import { Layout } from "./components/blocks";
import { CallbackPage, JuegoRuleta, LogoutPage, RouletteList, Selector } from "./pages";
import WauthProvider from "./auth/WauthProvider";
import { SiteProvider } from "./context/SiteContext";

function App() {
  return (
    <WauthProvider
      domain={"https://accounts.wargos.cloud"}
      clientId={"DBqTwXTGkuoVzv1YojUym0Z7bQseGx2S"}
      redirectUri={window.location.origin + "/callback"}
    >
      <SiteProvider>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<RouletteList />} />
            <Route path="juego-ruleta/:id" element={<JuegoRuleta />} />
            <Route path="roulette-list" element={<RouletteList />} />
          </Route>
          <Route path="selector" element={<Selector />} />
          <Route path="callback" element={<CallbackPage />} />
          <Route path="logout" element={<LogoutPage />} />
        </Routes>
      </SiteProvider>
    </WauthProvider>
  );
}

export default App;
